import { useSessionPermission } from '@btime/react-session'
import React from 'react'

import { SideMenuItem } from '../../../../components/navigation/SideMenu'
import { useNavigation } from '../../../../utils/contexts/NavigationContext'

const Item = ({ path, permission, ...props }) => {
  const valid = useSessionPermission(permission)
  const navigate = useNavigation()
  if (!!permission && !valid) return false

  return (
    <SideMenuItem
      onClick={e => {
        e.preventDefault()
        path && navigate(path)
      }}
      to={path}
      {...props}
    />
  )
}

export default Item
